import { render } from "./IconCheckCircle.vue?vue&type=template&id=b3649e9e"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconCheckCircle.vue"]])

export default __exports__